import { render, staticRenderFns } from "./SupplierReviewPod.vue?vue&type=template&id=88cb36b2&scoped=true"
import script from "./SupplierReviewPod.vue?vue&type=script&lang=js"
export * from "./SupplierReviewPod.vue?vue&type=script&lang=js"
import "./SupplierReviewPod.vue?vue&type=style&index=0&id=88cb36b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cb36b2",
  null
  
)

export default component.exports